import React from 'react';
import NormalComponents from './NormalComponents';
import SpecialComponents from './SpecialComponents';

import './Row.css'

const Row = (props) => {
  const { attr, layout, components, col, fillRemainCol, editMessageIndex, editRowIndex, editSlidePageIndex } = props;
  return (
    <div class="chatbot-row">
      {renderComponents(props)}
    </div>
  )
}

/**
 * Render components Root logic
 * @param {Object} param0 
 */
const renderComponents = (props) => {
  const {attr, layout, components, col, fillRemainCol} = props

  const getAttr_result = getAttr(attr)
  if (getAttr_result) {
    switch(getAttr_result.parent) {
      case "NORMAL":
        return <NormalComponents {...props}/>
      case "SPECIAL":
        return <SpecialComponents {...props}/>
      default:
        return (
          <p> 컴포넌트의 타입이 잘못되었습니다. </p>
        )
    }
  } else {
    console.error("Row의 attr은 Parsing이 되지 않는 데이터임 row.attr -> ", attr, " parse result -> ", getAttr_result)
    return (
      <p> 컴포넌트의 타입이 잘못되었습니다. </p>
    )
  }
}

export const getAttr = (attrString) => {
  let splited_attrString = null;
  try { 
    splited_attrString = attrString.split("/")
  } catch (e) {
    console.error("row.attr은 문자열이 아니거나 값에 문제가 있습니다.");
    console.error("받은 row.attr => ", attrString);
    return null;
  }

  // Array type 체크
  if (Array.isArray(splited_attrString)) {
    if (splited_attrString.length === 2) { // length === 2 여야함
      return {
        parent : splited_attrString[0],
        child : splited_attrString[1],
      };
    }
  }
  
  console.error("Row의 속성을 가져올 수 없습니다. 값을 확인해주세요");
  return null;
}

export default Row